import Vue from "vue";
import Vuex from "vuex";
import VuexPersistedState from "vuex-persistedstate";
import modules from "./modules";
import LogRocket from "logrocket";
import createPlugin from "logrocket-vuex";

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [
    VuexPersistedState({
      storage: window.sessionStorage
    }),
    logrocketPlugin
  ]
});
